import "core-js/modules/es.array.map";

var _Icon, _ServicesWrapper;

import React from 'react';
import classnames from 'classnames';
import { Container, LanguageSwitcher, Icon } from "../../../../Common";
import { useHeaderContext } from '../../HeaderContext';
import ServicesWrapper from './ServicesWrapper';
import HeaderDesktopLink from './HeaderDesktopLink';
import User from './User';
import styles from './DesktopNav.scss';

var DesktopNav = function DesktopNav(_ref) {
  var navigation = _ref.navigation,
      notifications = _ref.notifications,
      additionalContentSlot = _ref.additionalContentSlot,
      profileLinks = _ref.profileLinks,
      isOpened = _ref.isOpened,
      onClickLogin = _ref.onClickLogin,
      onClickLogout = _ref.onClickLogout,
      onOpenSearch = _ref.onOpenSearch,
      onActiveNavLinkClick = _ref.onActiveNavLinkClick,
      customHandleLangChange = _ref.customHandleLangChange;

  if (!isOpened) {
    return null;
  }

  var _useHeaderContext = useHeaderContext(),
      isServicesDisabled = _useHeaderContext.isServicesDisabled;

  return /*#__PURE__*/React.createElement("div", {
    className: styles.headerNav
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.links
  }, navigation.length > 0 && navigation.map(function (item) {
    return /*#__PURE__*/React.createElement(HeaderDesktopLink, {
      key: item.href,
      to: item.href,
      onActiveNavLinkClick: onActiveNavLinkClick
    }, item.title);
  })), additionalContentSlot && additionalContentSlot, /*#__PURE__*/React.createElement("div", {
    className: styles.controls
  }, /*#__PURE__*/React.createElement(LanguageSwitcher, {
    customHandleLangChange: customHandleLangChange
  }), !!onOpenSearch && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classnames(styles.controlItem, styles.searchButton),
    onClick: onOpenSearch
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    color: "text",
    name: "search"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.notificationsWrapper
  }, notifications), /*#__PURE__*/React.createElement(User, {
    onClickLogout: onClickLogout,
    profileLinks: profileLinks,
    onClickLogin: onClickLogin
  }), !isServicesDisabled && /*#__PURE__*/React.createElement(Container, {
    marginLeft: 3,
    className: styles.servicesWrapper
  }, _ServicesWrapper || (_ServicesWrapper = /*#__PURE__*/React.createElement(ServicesWrapper, null)))));
};

export default DesktopNav;